module.exports = __webpack_public_path__ + "img/1-3.1c5b2f07.svg";